import React from 'react'
import { withRouter } from 'react-router'
import { withHandlers } from 'recompose'
import PropTypes from 'prop-types'
import errorImg from '../../styles/images/error.png'
import CtaButton from '../buttons/cta-button'
import HeadingAlpha from '../headings/heading-alpha'
import InfoText from '../texts/info-text'

const Error = props => (
  <div className='error-page inner-wrapper'>
    <div className='error-image'>
      <img src={errorImg} alt='' />
    </div>
    <div className='error-msg'>
      <HeadingAlpha className='prominent-heading'>{props.message}</HeadingAlpha>
      <InfoText className='emphasis' hasIcon={false}>
        Live long and prosper or...
      </InfoText>
    </div>
    <CtaButton text='Back to home' onClick={props.backHome} />
  </div>
)

Error.propTypes = {
  message: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  backHome: PropTypes.func.isRequired
}

Error.defaultProps = {
  message: 'Page was not found'
}

const enhance = withHandlers({
  backHome: props => e => {
    e.preventDefault()
    props.history.push('/explore')
  }
})

export default withRouter(enhance(Error))



// WEBPACK FOOTER //
// ./src/ui/views/error.js